import { render, staticRenderFns } from "./DialogSwipe.vue?vue&type=template&id=6a473fd6&scoped=true"
import script from "./DialogSwipe.vue?vue&type=script&lang=js"
export * from "./DialogSwipe.vue?vue&type=script&lang=js"
import style0 from "./DialogSwipe.vue?vue&type=style&index=0&id=6a473fd6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a473fd6",
  null
  
)

export default component.exports